var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "BackArrow",

    getDefaultProps () {
        return {"width":"13px","height":"13px","viewBox":"0 0 13 13","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>backArrow</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Header-01-EventGroup" transform="translate(-210.000000, -203.000000)" fill="currentColor">
      <g id="backArrow" transform="translate(210.000000, 203.000000)">
        <g id="Shape">
          <polygon points="13 5.6875 3.0875 5.6875 7.6375 1.1375 6.5 0 0 6.5 6.5 13 7.6375 11.8625 3.0875 7.3125 13 7.3125"/>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/back-arrow.svg
 **/